import type { TFunction } from "i18next";
import { DomainTopics } from "@nexus/contracts";
import { stripTopicPrefix } from "./event-row-display";

const FALLBACK: Record<string, string> = {
  [stripTopicPrefix(DomainTopics.USERS)]: "Users",
  [stripTopicPrefix(DomainTopics.TENANTS)]: "Tenants",
  [stripTopicPrefix(DomainTopics.ACCESS)]: "Access",
  [stripTopicPrefix(DomainTopics.OPPORTUNITIES)]: "Opportunities",
  [stripTopicPrefix(DomainTopics.SYSTEM)]: "System",
  [stripTopicPrefix(DomainTopics.DATA_SYNC)]: "Data sync",
  [stripTopicPrefix(DomainTopics.AUTH)]: "Auth",
  [stripTopicPrefix(DomainTopics.INVITES)]: "Invites",
  [stripTopicPrefix(DomainTopics.PREFLIGHT)]: "Pre-flight",
  [stripTopicPrefix(DomainTopics.WORKSPACE)]: "Workspace",
  [stripTopicPrefix(DomainTopics.MARKETPLACE)]: "Marketplace",
  [stripTopicPrefix(DomainTopics.PERSONAS)]: "Personas",
  [stripTopicPrefix(DomainTopics.BETA_FEATURES)]: "Beta features",
};

export function eventTopicLabel(t: TFunction, topic: string): string {
  const key = stripTopicPrefix(topic);
  const fallback = Object.hasOwn(FALLBACK, key) ? FALLBACK[key] ?? key : key;
  return t(`admin.events.topics.${key}`, fallback);
}

export function hasEventTopicLabel(topic: string): boolean {
  return Object.hasOwn(FALLBACK, stripTopicPrefix(topic));
}
